import { useFieldArray, useFormContext } from "react-hook-form";
import { useState } from "react";
import AddItemPopup from "./AddItemPopup";
import Button from "../../../components/Button";

function AddContactItem() {
  const {
    control,
    formState: { errors },
    getValues,
  } = useFormContext();
  const { fields, append } = useFieldArray({
    control,
    name: "line_items",
    rules: {
      required: {
        value: true,
        message: "Please addd at least one item.",
      },
    },
    // shouldUnregister: true,
  });
  const [isOpen, setIsOpen] = useState(false);

  const contract_purchase_date = getValues("contract_purchase_date");
  return (
    <div className="max-w-[1000px] w-full mx-auto grid gap-y-10">
      <div className="grid gap-y-3">
        <div className="overflow-hidden">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-gray-900 font-semibold">Plan Details</h3>
            <Button
              variant="blackGray"
              btnClassName="w-[120px] font-normal"
              type="button"
              onClick={() => setIsOpen(true)}
            >
              Add an Item
            </Button>
          </div>
          <div className="overflow-hidden rounded-[10px] border border-gray-300 bg-white max-[900px]:hidden">
            <div className="overflow-auto">
              <table className="w-full min-w-[800px]">
                <thead>
                  <tr>
                    <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                      No.
                    </th>
                    <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                      Manufacturer
                    </th>
                    <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                      Model Number
                    </th>
                    <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                      Quantity
                    </th>
                    <th className="px-3 py-4 bg-zinc-500 text-sm text-white text-start font-normal">
                      Retail Price
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {fields.length > 0 ? (
                    fields.map((item, index) => (
                      <tr>
                        <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                          {index + 1}
                        </td>
                        <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                          {item?.["manufacturer"]}
                        </td>
                        <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                          {item?.["model_number"]}
                        </td>
                        <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                          {item?.["quantity"]}
                        </td>
                        <td className="px-3 py-4 text-sm text-gray-600 border-t border-gray-200">
                          ${item?.["product_retail_price"]}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={7}
                        className="text-lg text-center py-8 text-zinc-500"
                      >
                        No item added
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {errors?.line_items?.root?.message && (
            <p className="text-red-600 font-normal text-sm m-0 p-0 ml-1  bottom-0 left-0 right-0">
              {errors.line_items.root.message as string}
            </p>
          )}
          <div className="gap-4 min-[740px]:grid-cols-2 max-[900px]:grid hidden">
            {fields.map((item, index) => (
              <div
                key={item.id}
                className="rounded-xl overflow-hidden border border-gray-300 bg-white text-sm"
              >
                <div className="px-3 py-3 bg-zinc-500 text-white text-start font-normal flex items-center justify-between">
                  <h3>item: {index + 1}</h3>
                </div>
                <div className="p-3 grid gap-y-2.5">
                  <div className="flex items-center">
                    <p className="min-w-[120px] text-gray-900">Manufacturer</p>
                    <p className="text-gray-500">{item?.["manufacturer"]}</p>
                  </div>
                  <div className="flex items-center">
                    <p className="min-w-[120px] text-gray-900">Model Number</p>
                    <p className="text-gray-500">{item?.["model_number"]}</p>
                  </div>
                  <div className="flex items-center">
                    <p className="min-w-[120px] text-gray-900">Quantity</p>
                    <p className="text-gray-500">{item?.["quantity"]}</p>
                  </div>
                  <div className="flex items-center">
                    <p className="min-w-[120px] text-gray-900">Retail Price</p>
                    <p className="text-gray-500">
                      ${item?.["product_retail_price"]}
                    </p>
                  </div>
                  <div className="flex items-center">
                    <p className="min-w-[120px] text-gray-900">Category</p>
                    <p className="text-gray-500">
                      {item?.["product_category"]}
                    </p>
                  </div>
                  <div className="flex items-center">
                    <p className="min-w-[120px] text-gray-900">Status</p>
                    <p className="text-gray-500">{item?.["product_status"]}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <AddItemPopup
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        onSubmit={(values) => append(values)}
        contract_purchase_date={contract_purchase_date}
      />
    </div>
  );
}

export default AddContactItem;
